<template>
  <div class="center">
    <svg
      width="120"
      height="120"
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <circle cx="60" cy="60" r="60" fill="#EAFBFF" />
      <circle cx="60" cy="60" r="44" fill="#8BDFF5" />
      <text
        fill="white"
        xml:space="preserve"
        style="white-space: pre"
        font-family="Lato"
        font-size="30"
        font-weight="bold"
        letter-spacing="0px">
        <tspan x="30" y="71.61">{{clarity.score}}%</tspan>
      </text>
    </svg>
  </div>
</template>

<script>
import Vue from "vue";

export default {
  props: ["clarity"]
};
</script>

<style lang="scss" scoped>
.center {
  display: flex;
  justify-content: space-around;
  padding-top: 50px;
  // height: 100%;
}
</style>


